import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useAuthorization } from "../../../../hooks/useAuthorization";
import { ContentHeader } from "../../../general/modules/commons/content/contentHeader";
import { Content } from "../../../general/modules/commons/content/content";
import { CustomFilters } from "../../../general/crudGraphql/domain/models/graphqlModel";

type Props = {
  entity: string;
  filters: CustomFilters;
};

const EntityLogsProtected = ({ entity, filters }: Props) => {
  const { t } = useTranslation("common");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <Content className={"mt-4"}>
      <div className={"d-flex flex-row"}>
        <ContentHeader title={t("crud.logs.header.title")} />

        <Button className="btn btn-primary ms-auto" onClick={handleShow}>
          {t("crud.logs.showLogs")}
        </Button>
      </div>

      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>{t(`${entity}.logs`)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
            src={`/logs/${encodeURIComponent(JSON.stringify(filters))}`}
            style={{
              width: "100%",
              height: "80vh",
              minHeight: "300px",
              border: "none",
            }}
          />
        </Modal.Body>
      </Modal>
    </Content>
  );
};

export const EntityLogs = ({ entity, filters }: Props) => {
  const { hasRole } = useAuthorization();

  if (hasRole("dbh-manager") || hasRole("super-admin")) {
    return <EntityLogsProtected entity={entity} filters={filters} />;
  }
  return <></>;
};
